/** Shared labels/keys for account onboarding network step and read-only summaries. */
export const ACCOUNT_BASE_NETWORK_FIELDS: Array<{ key: string; label: string }> = [
	{ key: 'vpcName', label: 'tag:Name' },
	{ key: 'vpcCidrBlock', label: 'VPC CIDR Block' },
	{ key: 'vpcAvailabilityZones', label: 'VPC Availability Zones' },
	{ key: 'privateSubnetsCidr', label: 'Private Subnets CIDR' },
	{ key: 'tgwSubnetsCidr', label: 'TGW Subnets CIDR' },
	{ key: 'requestTgwAttachment', label: 'Request TGW Attachment' },
	{ key: 'isCoreVpc', label: 'Is Core VPC' },
	{ key: 'createPrivateHostedZone', label: 'Create Private Hosted Zone' },
	{ key: 'associateDnsResolverRules', label: 'Associate DNS Resolver Rules' },
	{ key: 'useCentralizedVpcInterfaceEndpoints', label: 'Use Centralized VPC Interface Endpoints' },
	{ key: 'privateHostedZoneName', label: 'Private Hosted Zone Name' }
]

export const ACCOUNT_SECONDARY_CIDR_FIELDS: Array<{ key: string; label: string }> = [
	{ key: 'secondaryCidrBlock', label: 'Secondary CIDR Block' },
	{ key: 'publicCidrBlock', label: 'Public CIDR' }
]

export const ACCOUNT_NETWORK_ALL_FIELDS = [
	...ACCOUNT_BASE_NETWORK_FIELDS,
	...ACCOUNT_SECONDARY_CIDR_FIELDS
]
